import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import { fetchData } from "../helper/api.interceptor";

const EditSolarPanelModal = ({ show, onClose, editData, refreshList }) => {
    const [formData, setFormData] = useState({
        name: "",
        displayName: "",
        capacityWatt: "",
        efficiency: "",
        price: "",
        type: "",
        suitableFor: "",
        image: null,
    });

    useEffect(() => {
        if (editData) {
            setFormData({
                name: editData.name || "",
                displayName: editData.name || "",
                capacityWatt: editData.capacityWatt || "",
                efficiency: editData.efficiency || "",
                price: editData.price || "",
                type: editData.type || "",
                suitableFor: (editData.suitableFor || []).join(", "),
                image: null,
            });
        } else {
            setFormData({
                name: "",
                displayName: "",
                capacityWatt: "",
                efficiency: "",
                price: "",
                type: "",
                suitableFor: "",
                image: null,
            });
        }
    }, [editData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
    };

    const handleSubmit = async () => {
        const payload = new FormData();
        payload.append("name", formData.name);
        payload.append("displayName", formData.name);
        payload.append("capacityWatt", formData.capacityWatt);
        payload.append("efficiency", formData.efficiency);
        payload.append("price", formData.price);
        payload.append("type", formData.type);
        payload.append("suitableFor", formData.suitableFor);
        if (formData.image) {
            payload.append("image", formData.image);
        }

        try {
            if (editData && editData.id) {
                await fetchData.post(`/solar/update?id=${editData.id}`, payload);
                Swal.fire("Updated!", "Solar panel updated successfully", "success");
            } else {
                await fetchData.post("/solar/add", payload);
                Swal.fire("Added!", "Solar panel added successfully", "success");
            }

            onClose();
            refreshList();
        } catch (err) {
            Swal.fire("Error", "Something went wrong", "error");
        }
    };
    useEffect(() => {
        const fetchSolarPanel = async () => {
            if (editData?.id) {
                try {
                    const res = await fetchData.get(`/solar/by-id?id=${editData.id}`);
                    const data = res.result;

                    setFormData({
                        name: data.name || "",
                        displayName: data.displayName || "",
                        capacityWatt: data.capacityWatt || "",
                        efficiency: data.efficiency || "",
                        price: data.price || "",
                        type: data.type || "",
                        suitableFor: (data.suitableFor || []).join(", "),
                        image: null,
                    });
                } catch (err) {
                    console.error("Failed to fetch solar panel", err);
                    Swal.fire("Error", "Failed to load solar panel data", "error");
                }
            } else {
                setFormData({
                    name: "",
                    displayName: "",
                    capacityWatt: "",
                    efficiency: "",
                    price: "",
                    type: "",
                    suitableFor: "",
                    image: null,
                });
            }
        };

        fetchSolarPanel();
    }, [editData]);
    if (!show) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {editData ? "Edit Solar Panel" : "Add Solar Panel"}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Name *</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                />
                            </div>
                            {/* <div className="col-md-6 mb-3">
                                <label className="form-label">Display Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="displayName"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                />
                        </div> */}
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Capacity (Watt) *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="capacityWatt"
                                    value={formData.capacityWatt}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Efficiency (%) *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="efficiency"
                                    value={formData.efficiency}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Price *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="price"
                                    value={formData.price}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Type</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="type"
                                    value={formData.type}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Suitable For (comma separated)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="suitableFor"
                                    value={formData.suitableFor}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={handleImageChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                        <button className="btn btn-primary" onClick={handleSubmit}>
                            {editData ? "Update" : "Add"}
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default EditSolarPanelModal;
